import { TIME_TRACKING_TIME_FORMAT } from '@app/constants';
import { TimesheetEntry } from '@app/models/time-tracking/timesheet-entry.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import moment from 'moment';

export class StartEndTimeColumn extends Column {
    title = 'time-tracking.timesheetsIndexPage.table.startEndTime';
    type: CellDisplay = CellDisplay.string;
    sortable = true;
    sortField = 'timeClockEntry.startTime';

    getDisplayPropertyValue(timesheetEntry: TimesheetEntry): string {
        if (!timesheetEntry.timeClockEntry) {
            return '-';
        }

        return (
            moment(timesheetEntry.timeClockEntry?.startTime).format(TIME_TRACKING_TIME_FORMAT[timesheetEntry.locale]) +
            ' - ' +
            moment(timesheetEntry.timeClockEntry?.endTime).format(TIME_TRACKING_TIME_FORMAT[timesheetEntry.locale])
        );
    }
}
